import { styled } from '@mui/material/styles';
import { Box, Paper, Typography, Divider, Button } from '@mui/material';

// Paper wrapper with conditional styling: page layout vs modal surface
export const SettingsPaper = styled(Paper, { shouldForwardProp: (prop) => prop !== 'isModal' })(
  ({ theme, isModal }) => ({
    padding: theme.spacing(3),
    width: '100%',
    maxWidth: 600,
    marginTop: isModal ? 0 : theme.spacing(5),
    marginLeft: isModal ? 0 : 'auto',
    marginRight: isModal ? 0 : 'auto',
    boxShadow: isModal ? 'none' : undefined,
    borderRadius: isModal ? 0 : undefined,
    backgroundColor: isModal ? 'transparent' : undefined,
    backgroundImage: isModal ? 'none' : undefined,
    border: isModal ? 'none' : undefined,
    backdropFilter: isModal ? 'none' : undefined,
  })
);

// Header container with title and close icon
export const HeaderContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: theme.spacing(2),
}));

export const HeaderTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
}));

// Styled divider with bottom margin
export const DividerStyled = styled(Divider)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

// Section wrapper for form fields and buttons
export const Section = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

// Button for username update with top margin
export const ChangeButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(1),
}));
